import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-copy",
  templateUrl: "./copy.component.html",
  styleUrls: ["./copy.component.scss"],
})
export class CopyComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
